<template>
  <div>
    <transition name="model">
      <form @submit.prevent="submitForm">
        <div class="modal_mask">
          <div class="blurringbackground" :class="{ show: vmodal }"></div>
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Editar RRIttM</h4>
                  <button @click="finish_modal" class="close_button"></button>
                </div>
              </div>
            </div>

            <div class="modal-body">
              <div class="card-header">
                <ul>
                  <li>
                    <a :class="[active_rrim, 'nav-link']" @click="click_rrim"
                      >RRIM</a
                    >
                  </li>
                  <li>
                    <a :class="[active_fotos, 'nav-link']" @click="click_fotos"
                      >Fotos</a
                    >
                  </li>
                  <li>
                    <a :class="[active_lsp, 'nav-link']" @click="click_lsp"
                      >LSP</a
                    >
                  </li>
                </ul>
              </div>

              <div class="tab-content">
                <div v-show="rrim">
                  <RRIM
                    @setObjOfInforGeral="getObjOfInforGeral"
                    @setListPro="getListPro"
                    @setObjMoldeFechado="getObjMoldeFechado"
                    @setObjMoldeAberto="getObjMoldeAberto"
                    @setCavity="getCavity"
                  />
                </div>
                <div v-show="fotos" class="fotos">
                  <FOTOS @SendDataImages="getObjAllImages" />
                </div>

                <div v-show="lsp">
                  <LSP :configInputs="0" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-blue"
                @click="click_close_modal"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn"
                @click="submit"
                data-dismiss="modal"
              >
                Salvar Edição
              </button>
              <!-- <button type="submit" class="btn btn-success font-weight-bold">
                Salvar
              </button> -->
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { PutDataImagesLSP } from "../../../controllers/RRIM/PutDataImagesLSP";
import { PutDataImagesRRIM } from "../../../controllers/RRIM/PutDataImagesRRIM";
import { PutDataRRIM } from "../../../controllers/RRIM/PutDataRRIM";
import { sap } from "../../../http/index";
import FOTOS from "./Modules/FOTOSRRIM/LayoutView.vue";
import LSP from "./Modules/LSP/LayoutView.vue";
import RRIM from "./Modules/RRIM/LayoutView.vue";

// import { required, minLength } from '@vuelidate/validators'

export default {
  components: {
    RRIM,
    FOTOS,
    LSP,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      statusHomologacao: false,
      modalHomologacao: false,
      showConfirmacao: false,
      ComentarioHomolgacao: "",
      active_rrim: "active-tab",
      active_fotos: "",
      active_lsp: "",
      vmodal: true,
      rrim: true,
      fotos: false,
      lsp: false,

      dados: {
        InforGeral: Object,
        Produtos: Object,
        Molde_Fechado: Object,
        Molde_Aberto: Object,
      },
      dadosImages: Object,
      cavityTotal: null,
    };
  },
  mounted() {
    document.body.classList.add("sc");
  },
  beforeUnmount() {
    document.body.classList.remove("sc");
  },
  methods: {
    getCavity(value) {
      this.cavityTotal = value;
    },
    async submit() {
      const toast = await this.$swal
        .fire({
          title: "Deseja realizar a edição?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      await this.$store.commit("SetLoadingPattern", true); // insere o loading

      const data = await this.$store.getters.$GetDataAllRRIM;

      if (data != undefined) {
        this.dados.Molde_Fechado.checklist =
          this.$store.getters.$GetDataEmitsUpdate.checklist;
        this.dados.Produtos = this.$store.getters.$GetDataEmitsUpdate.produtos;

        if (!this.dados.Molde_Aberto.tipo_de_injecao) {
          this.dados.Molde_Aberto.tipo_de_injecao = {};
        }

        this.dados.Molde_Aberto.tipo_de_injecao.camera_quente =
          this.dados.Molde_Fechado.camera_quente.showCameraQuente;

        let qtdCavidades = 0;

        if (Array.isArray(this.dados.Molde_Aberto.lista_ProdutoAndCavidades)) {
          this.dados.Molde_Aberto.lista_ProdutoAndCavidades.forEach((item) => {
            qtdCavidades += Number(item.ncavidade) || 0;
          });
        } else {
          console.warn(
            "lista_ProdutoAndCavidades não é um array:",
            this.dados.Molde_Aberto.lista_ProdutoAndCavidades
          );
        }

        const { data: moldeSapConsulta } = await sap.get(`/mold`, {
          params: {
            unidade: "JPA",
            mold_code: this.$store.state.DataAllRRIM.InforGeral.MOLDE,
          },
        });

        const numeroTotaldeCavid = moldeSapConsulta[0].cavidade;

        if (qtdCavidades > numeroTotaldeCavid) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: "Quantidade de Cavidades Excedida",
          });

          await this.$store.commit("SetLoadingPattern", false); // insere o loading

          return;
        }

        if (qtdCavidades <= 0) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: "A RRIM deve possuir um ou mais produtos no molde aberto",
          });

          await this.$store.commit("SetLoadingPattern", false); // insere o loading

          return;
        }

        const res = await PutDataRRIM(data.InforGeral.ID, this.dados);

        const DataImage = this.$store.getters.$GetDataImages;

        // Abertura de Embalagem
        const formDataImages = new FormData();
        formDataImages.append(
          "IMG_EMB_EXT",
          DataImage.AberturaEmbalagem.fotoEmbalagemE
        );
        formDataImages.append(
          "IMG_EMB_INT",
          DataImage.AberturaEmbalagem.fotoEmbalagemI
        );
        formDataImages.append(
          "IMG_EMB_EXTRA",
          DataImage.AberturaEmbalagem.fotoEmbalgemExtra.file
        );

        formDataImages.append(
          "IMG_EMB_EXTRA_DESC",
          DataImage.AberturaEmbalagem.fotoEmbalgemExtra.description
        );

        //  Molde Fechado
        formDataImages.append(
          "IMG_MF_PLA_ID",
          DataImage.MoldeFechado.FotoPlaquetadeIdentificacaodomoldeFile
        );
        formDataImages.append(
          "IMG_MF_CAM_QUENTE",
          DataImage.MoldeFechado.IDdaCâmaraQuenteFile
        );
        formDataImages.append(
          "IMG_MF_L_DIREITO",
          DataImage.MoldeFechado.FotodoLadoDireitoFile
        );
        formDataImages.append(
          "IMG_MF_L_ESQUERDO",
          DataImage.MoldeFechado.FotodoLadoEsquerdoFile
        );
        formDataImages.append(
          "IMG_MF_PLA_L_MOVEL",
          DataImage.MoldeFechado.FotodaPlacadoLadoMovelFile
        );
        formDataImages.append(
          "IMG_MF_PLA_L_FIXO",
          DataImage.MoldeFechado.FotodaPlacadoLadoFixoFile
        );
        formDataImages.append(
          "IMG_MF_L_SUPERIOR",
          DataImage.MoldeFechado.FotodoLadoSuperiorFile
        );
        formDataImages.append(
          "IMG_MF_PLA_SIS_REF",
          DataImage.MoldeFechado.FotodaPlaquetadosistemadeRefrigeraçãoFile
        );

        // Molde Aberto
        formDataImages.append(
          "IMG_MA_F_L_FIXO",
          DataImage.MoldeAberto.FotodaFacedoLadoFixoFile
        );
        formDataImages.append(
          "IMG_MA_F_L_MOVEL",
          DataImage.MoldeAberto.FotodaFacedoLadoMovelFile
        );
        formDataImages.append(
          "IMG_MA_EXTRA",
          DataImage.MoldeAberto.fotoMoldeAbertoExtra.file
        );

        formDataImages.append(
          "IMG_MA_EXTRA_DESC",
          DataImage.MoldeAberto.fotoMoldeAbertoExtra.description
        );

        formDataImages.append("IMAGEM_CAF", DataImage.CAF.file);
        formDataImages.append("IMAGEM_CAF_DESC", DataImage.CAF.description);

        await this.$store.commit("SetLoadingPattern", false); // insere o loading

        await PutDataImagesRRIM(data.InforGeral.ID, formDataImages);

        // LSP
        const DataImagesLSP = this.$store.getters.$GetImagesLSP;

        if (
          DataImagesLSP != undefined ||
          DataImagesLSP != "" ||
          DataImage.length != 0
        ) {
          let formDataLSP = new FormData();
          await DataImagesLSP.map((element) => {
            if (typeof element.file === "string") {
              formDataLSP.append("listIdOfUpdate[]", element.id);
            } else {
              formDataLSP.append("fotoEmbalagem[]", element.file);
              formDataLSP.append("descfotoEmbalagem[]", element.desc);
              formDataLSP.append(
                "quantidadefotoEmbalagem[]",
                element.quantidade
              );
              formDataLSP.append(
                "observacaofotoEmbalagem[]",
                element.observacao
              );
            }
          });

          const ImagesRRIMLSP = await PutDataImagesLSP(
            data.InforGeral.ID,
            formDataLSP
          );
        }

        if (res.status == 201) {
          const Toast = await this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Editado com Sucesso",
          });
        }
        window.location.reload();
        this.$store.commit("MutationSetCancelModalEditRRIM", false);
        return;
      }
    },

    async click_close_modal() {
      const toast = await this.$swal
        .fire({
          title: "Deseja cancelar edição de RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      this.$store.commit("MutationSetCancelModalEditRRIM", false);
    },
    click_rrim() {
      this.rrim = true;
      this.fotos = false;
      this.lsp = false;
      this.active_rrim = "active-tab";
      this.active_fotos = "";
      this.active_lsp = "";
    },

    click_fotos() {
      this.rrim = false;
      this.fotos = true;
      this.lsp = false;
      this.active_rrim = "";
      this.active_fotos = "active-tab";
      this.active_lsp = "";
    },

    click_lsp() {
      this.rrim = false;
      this.fotos = false;
      this.lsp = true;
      this.active_rrim = "";
      this.active_fotos = "";
      this.active_lsp = "active-tab";
    },

    finish_modal() {
      this.$store.commit("MutationSetCancelModalEditRRIM", false);
      this.vmodal = !this.vmodal;
    },

    getObjOfInforGeral(val) {
      this.dados.InforGeral = val;
    },

    getListPro(val) {
      this.dados.Produtos = val;
    },

    getObjAllImages(val) {
      this.dadosImages = val;
    },

    getObjMoldeFechado(val) {
      this.dados.Molde_Fechado = val;
    },

    getObjMoldeAberto(val) {
      this.dados.Molde_Aberto = val;
    },
  },
};
</script>

<style scoped>
h4 {
  color: var(--font_color);
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 1.7rem;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: white;
  padding: 20px;
  border-radius: 10px;
}

.blurringbackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(3px);
  transition: opacity 0.3s ease, visibility 0.3s ease;
  visibility: hidden;
  opacity: 0;
}

.blurringbackground.show {
  visibility: visible;
  opacity: 1;
}

.close_button {
  background-image: url("../../../static/icons/close_iconblack.svg");
  background-repeat: no-repeat;
  background-size: 70%;
  background-position: center;
  width: 1.5rem;
  height: 1.5rem;
  background-color: rgba(255, 0, 0, 0);
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.3s ease;
  transition: outline 0.3s ease;
}

.close_button:hover {
  background-color: var(--gray);
  outline: 6px solid var(--gray);
}

.modal_mask {
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}

@keyframes growIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes growOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

.modal_mask .modal_content {
  position: relative;
  width: 80%;
  margin: 8vh auto;
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  box-shadow: 4px 4px 5px rgba(75, 74, 74, 0.5);
  animation: growIn 0.15s ease-out forwards;
}

.modal_header {
  width: 100%;
  padding: 1rem 2.3rem 0rem;
}

.title_modal {
  display: flex;
  align-items: center;
  width: 100%;
}

.flex {
  display: flex !important;
  flex-direction: row !important;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0rem;
}

.card-header {
  padding: 0.5rem 3rem;
}

.card-header ul {
  display: flex;
  gap: 2rem;
  list-style-type: none;
  justify-content: center;
}

.card-header ul li {
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 0.5rem;
  cursor: pointer;
  width: 5rem;
  border: 2px solid var(--font_color);
}

.card-header ul li:active {
  color: white !important;
  background-color: var(--font_color);
}

.card-header ul li a {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--font_color);
  font-weight: 500;
  font-family: "Poppins", sans-serif !important;
  width: 10.5rem;
  height: 2.8rem;
}

.card-header ul li a:hover {
  font-weight: 800;
}

.card-header ul li a:checked {
  color: white !important;
}

.card-header ul li a:active {
  color: white !important;
}

.active-tab {
  background-color: var(--font_color);
  color: white !important;
}

.tab-content {
}

.modal-footer {
  display: flex;
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  width: 100%;
  flex-direction: row-reverse;
}

.btn {
  color: var(--font_color);
  font-weight: 800;
  transition: all 0.3s ease;
}

.btn:hover {
  color: black;
  font-weight: 800;
  background-color: var(--font_color);
  color: white;
}

.btn1 {
  border: 2px solid;
  background-color: white;
  color: var(--font_color);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn1.aprovar {
  border-color: var(--green);
  color: var(--green);
}

.btn1.aprovar:hover {
  background-color: var(--green);
  color: white;
}

.btn1.reprovar {
  border-color: var(--red);
  color: var(--red);
}

.btn1.reprovar:hover {
  background-color: var(--red);
  color: white;
}

.btn1.cancelar {
  border-color: orange;
  color: orange;
}

.btn1.cancelar:hover {
  background-color: orange;
  color: white;
}

.modal-header {
  padding: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.modal-comentario {
  padding: 1rem;
}

.modal-buttons {
  display: flex;
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  width: 100%;
  flex-direction: row-reverse;
}

.textarea_hom {
  width: 100% !important;
  border-radius: 10px !important;
  border: 1px solid #d9d9d9;
  padding: 0.5rem;
  color: var(--font_color);
}

.textarea_hom:hover {
  border: 1.5px solid var(--green);
  color: green;
}

@media (max-width: 1526px) {
  .modal_mask .modal_content {
    width: 95% !important;
  }
}
@media (max-width: 450px) {
  .modal_mask .modal_content {
    width: 95% !important;
  }
}
</style>
